<div class="wrapper">
    <span class="beforeUpper"></span>
    <span class="beforeLower"></span>
    <div class="label">{{ label }}</div>
    <span class="after"></span>
</div>
